import moment from 'moment';
import { createListAction } from '../../../../EdgeControllersListPage/shared/lib/edgeListHelper';
import { FORMAT_FOR_API } from '../../../../../common/constants/commonConstants';

const activitiesFilterLogic = (filterId, filterValue, row) => {
  if (filterId === 'timestamp') {
    const cellDateUtc = moment.utc(Number(row.timestamp)).format(FORMAT_FOR_API);

    return cellDateUtc === filterValue;
  }
};

export const getEdgeActivities = (rows) => createListAction(rows, activitiesFilterLogic);
